import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import TantentSelect from '@/store/entities/TantentSelect'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface ConfigurationSettingState extends ListState<any> {
    editBaseSetting: TantentSelect;
}
class ConfigurationSettingModule extends ListModule<ConfigurationSettingState, any, TantentSelect>{
    state = {
        id:0,
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
        editBaseSetting: TantentSelect,
    }
    actions = {
        async getAll(context: ActionContext<ConfigurationSettingState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/PddTokenManagement/GetPddTokenRecordAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<ConfigurationSettingState, any>, payload: any) {
            await Ajax.post('/api/services/app/PddTokenManagement/CreateAndEntityPddTokenRecord', payload.data);
        },
        async updateStatus(context: ActionContext<ConfigurationSettingState, any>, payload: any) {
            let rep = await Ajax.post('/api/services/app/PddTokenManagement/UpdateStatus', payload.data);
        },
        async ClearCache(context: ActionContext<ConfigurationSettingState, any>, payload: any) {
            await Ajax.get('http://47.115.20.93/api/services/app/PddCloudCache/ClearCache', payload.data);
        },
        async update(context: ActionContext<ConfigurationSettingState, any>, payload: any) {
            await Ajax.post('/api/services/app/PddTokenManagement/CreateAndEntityPddTokenRecord', payload.data);
        },
        async updatestan(context: ActionContext<ConfigurationSettingState, any>, payload: any) {
            await Ajax.get('/api/services/app/PddTokenManagement/UpdateAvailableStatus', payload.data);
        },
        async delete(context: ActionContext<ConfigurationSettingState, any>, payload: any) {
            await Ajax.post('/api/services/app/PddTokenManagement/DeletePddToken?PddTokenId=' + payload.data.id);
        },
       
        async gettenantAll(context: ActionContext<ConfigurationSettingState, any>, payload: any) {

            var loginList = await Ajax.get('/api/services/app/PddTokenManagement/GetTenantList');
            return loginList.data.result;
        },
    };
    mutations = {
        setCurrentPage(state: ConfigurationSettingState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ConfigurationSettingState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: ConfigurationSettingState, tenant: TantentSelect) {
            state.editBaseSetting = tenant;
        }
    }
}
const configurationSettingModule = new ConfigurationSettingModule();
export default configurationSettingModule;